import { Alert, AlertTitle } from '@mui/material'

import { MUI } from 'components'

import { TemporaryPasswordAlertType } from './temporaryPasswordAlert.types'

const TemporaryPasswordAlert = ({ onClick }: TemporaryPasswordAlertType) => {
  return (
    <Alert
      severity="warning"
      action={
        <MUI.Button onClick={onClick} color="inherit" size="small">
          Cadastrar senha
        </MUI.Button>
      }
    >
      <AlertTitle>Você está utilizando uma senha temporária</AlertTitle>
      Cadastre uma nova senha para manter sua conta segura.
    </Alert>
  )
}

export default TemporaryPasswordAlert
